// collections.js
const Fonts = {
  // === Sans Serif (UI / Body) ===
  inter: "'Inter', sans-serif",
  roboto: "'Roboto', sans-serif",
  poppins: "'Poppins', sans-serif",
  montserrat: "'Montserrat', sans-serif",
  lato: "'Lato', sans-serif",
  openSans: "'Open Sans', sans-serif",
  nunito: "'Nunito', sans-serif",
  rubik: "'Rubik', sans-serif",
  workSans: "'Work Sans', sans-serif",
  sourceSansPro: "'Source Sans Pro', sans-serif",
  heebo: "'Heebo', sans-serif",
  dmSans: "'DM Sans', sans-serif",
  kumbhSans: "'Kumbh Sans', sans-serif",
  barlow: "'Barlow', sans-serif",
  exo: "'Exo', sans-serif",
  manrope: "'Manrope', sans-serif",
  mulish: "'Mulish', sans-serif",
  urbanist: "'Urbanist', sans-serif",
  outfit: "'Outfit', sans-serif",
  spartan: "'League Spartan', sans-serif",
  asap: "'Asap', sans-serif",
  oxygen: "'Oxygen', sans-serif",
  mavenPro: "'Maven Pro', sans-serif",
  josefinSans: "'Josefin Sans', sans-serif",
  cabin: "'Cabin', sans-serif",

  // === Serif (Headings / Articles) ===
  merriweather: "'Merriweather', serif",
  playfair: "'Playfair Display', serif",
  robotoSerif: "'Roboto Serif', serif",
  lora: "'Lora', serif",
  crimsonText: "'Crimson Text', serif",
  abrilFatface: "'Abril Fatface', serif",
  cormorant: "'Cormorant Garamond', serif",
  cardo: "'Cardo', serif",
  kurale: "'Kurale', serif",
  labrada: "'Labrada', serif",
  ptSerif: "'PT Serif', serif",
  domine: "'Domine', serif",
  volkhov: "'Volkhov', serif",
  notoSerif: "'Noto Serif', serif",
  abril: "'Abril Fatface', serif",
  alegreya: "'Alegreya', serif",
  zilla: "'Zilla Slab', serif",

  // === Display / Decorative ===
  oswald: "'Oswald', sans-serif",
  bebasNeue: "'Bebas Neue', sans-serif",
  bungee: "'Bungee', cursive",
  anton: "'Anton', sans-serif",
  alata: "'Alata', sans-serif",
  lalezar: "'Lalezar', cursive",
  kumarOne: "'Kumar One', cursive",
  lacquer: "'Lacquer', cursive",
  lakkiReddy: "'Lakki Reddy', cursive",
  fredokaOne: "'Fredoka One', cursive",
  sigmar: "'Sigmar', cursive",
  amaticSC: "'Amatic SC', cursive",
  permanentMarker: "'Permanent Marker', cursive",
  rampart: "'Rampart One', cursive",
  pressStart: "'Press Start 2P', cursive",
  chela: "'Chela One', cursive",

  // === Script / Handwriting ===
  pacifico: "'Pacifico', cursive",
  dancingScript: "'Dancing Script', cursive",
  greatVibes: "'Great Vibes', cursive",
  shadowsIntoLight: "'Shadows Into Light', cursive",
  indieFlower: "'Indie Flower', cursive",
  satisfy: "'Satisfy', cursive",
  caveat: "'Caveat', cursive",
  laBelleAurore: "'La Belle Aurore', cursive",
  sacramento: "'Sacramento', cursive",
  cookie: "'Cookie', cursive",
  parisienne: "'Parisienne', cursive",
  allura: "'Allura', cursive",
  kaushanScript: "'Kaushan Script', cursive",
  architect: "'Architects Daughter', cursive",
  handwriting: "'Homemade Apple', cursive",

  // === Monospace (Code / UI) ===
  jetbrainsMono: "'JetBrains Mono', monospace",
  robotoMono: "'Roboto Mono', monospace",
  sourceCodePro: "'Source Code Pro', monospace",
  inconsolata: "'Inconsolata', monospace",
  firaCode: "'Fira Code', monospace",
  spaceMono: "'Space Mono', monospace",
  ubuntuMono: "'Ubuntu Mono', monospace",
  courierPrime: "'Courier Prime', monospace",

  // === System fallback ===
  systemSans: "system-ui, sans-serif",
  systemSerif: "ui-serif, serif",
  systemMono: "ui-monospace, monospace",
  arial: "Arial, sans-serif",
  georgia: "Georgia, serif",
  verdana: "Verdana, sans-serif",
  trebuchet: "'Trebuchet MS', sans-serif",
  courier: "'Courier New', monospace",
  times: "'Times New Roman', serif",
};

const FontSizes = [12, 14, 16, 18, 20, 24, 30, 36, 38, 60, 72, 96, 128];

const FontWeights = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,

  // === Italics (CSS requires fontStyle: 'italic') ===
  "thin Italic": { weight: 100, style: "italic" },
  "extra Light Italic": { weight: 200, style: "italic" },
  "light Italic": { weight: 300, style: "italic" },
  italic: { weight: 400, style: "italic" },
  "medium Italic": { weight: 500, style: "italic" },
  "semi Bold Italic": { weight: 600, style: "italic" },
  "bold Italic": { weight: 700, style: "italic" },
  "extra Bold Italic": { weight: 800, style: "italic" },
  "black Italic": { weight: 900, style: "italic" },
};

export { Fonts, FontSizes, FontWeights };
